import React from 'react';
import '../template-file-css/document-file-template.css';


export const GHP_CourtReport = ({ itemsRef, showErrorFor }) => {
    {/*write name of assessment inplace of "Assessment_Name"*/ }

    return (
        <form id='GHP_CourtReport' className='file-pdf-document'> {/*write name of assessment inplace of "Assessment_Name"*/}
            <div className='file-template'>

                {/* Start HTML code from here */}


                <h3>
                    Agency Information</h3>
                <span className='small'>Include agency name, address and phone number.</span>
                <br />
                <textarea id="txtAgencyInformation" name="txtAgencyInformation" className='add-only'></textarea>
                <h3>
                    Court Information</h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>File Number:</span>
                            <input type='text' id="txtFileNumber" name="txtFileNumber" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Case Number:</span>
                            <input type='text' id="txtCaseNumber" name="txtCaseNumber" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Charge:</span>
                            <input type='text' id="txtCharge" name="txtCharge" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Staff Person Assigned:</span>
                            <input type='text' id="staffname" name="staffName" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Hearing Date:</span>
                            <input type='date' id="dtHearingDate" name="dtHearingDate" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Type of Hearing:</span>
                            <input type='text' id="txtHearingType" name="txtHearingType" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Judge:</span>
                            <input type='text' id="txtJudge" name="txtJudge" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Referral Source/PO:</span>
                            <input type='text' id="txtReferralSource" name="txtReferralSource" className='add-only' />
                        </td>
                    </tr>
                </table>
                <div>
                    <h3>
                        Consumer Information</h3>
                    <table>
                        <tr>
                            <td className='w-375'>
                                <span className='eleHeader'>Consumer's Name:</span>
                                <input type='text' id="txtConsumersName" name="txtConsumersName" className='add-only' />
                            </td>
                            <td className='w-375'>
                                <span className='eleHeader'>Date of Birth:</span>
                                <input type='date' id="dtDOB" name="dtDOB" className='add-only' />
                            </td>
                        </tr>
                        <tr>
                            <td className='w-375'>
                                <span className='eleHeader'>Gender:</span>
                                <select id="ddlGender" name="ddlGender" className='add-only'>
                                    <option value="Na"></option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                </select>
                            </td>
                            <td className='w-375'>
                                <span className='eleHeader'>Current Placement:</span>
                                <input type='text' id="txtCurrentPlacement" name="txtCurrentPlacement" className='add-only' />
                            </td>
                        </tr>
                    </table>
                </div>
                <div>
                    <h3>
                        History</h3>
                    <p>
                        <span className='eleHeader'>Court History:</span>
                        <textarea id="txtCourtHistory" name="txtCourtHistory" className='add-only'></textarea></p>
                    <h3>
                        Pertinent Information</h3>
                    <p>
                        Therapeutic Information</p>
                    <table>
                        <tr>
                            <td className='w-375'>
                                <span className='eleHeader'>Session Start Date:</span>
                                <input type='date' id="dtSessionStartDate" name="dtSessionStartDate" className='add-only' />
                            </td>
                            <td className='w-375'>
                                <span className='eleHeader'>Total Number of Sessions:</span>
                                <input type='text' id="txtNumberOfSessions" name="txtNumberOfSessions" className='add-only' />
                            </td>
                        </tr>
                        <tr>
                            <td className='w-750'>
                                <span className='eleHeader'>Frequency of Sessions:</span>
                                <textarea id="txtFrequencyOfSessions" name="txtFrequencyOfSessions" className='add-only'></textarea>
                            </td>
                        </tr>
                    </table>
                </div>
                <p>
                    <span className='eleHeader'>Type of services provided:</span>
                    <textarea id="txtServicesProvided" name="txtServicesProvided" className='add-only'></textarea></p>
                <p>
                    <span className='eleHeader'>Other Services Provided</span>
                    <span className='small'>Instructions: Attach additional documentation if needed to report</span>
                    <textarea id="txtOtherServices" name="txtOtherServices" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Date psychiatric assessment completed?</span>
                            <input type='date' id="dtPsychiatricCompleted" name="dtPsychiatricCompleted" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Date psychological assessment completed?</span>
                            <input type='date' id="dtPsychologicalCompleted" name="dtPsychologicalCompleted" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Date biopsychosocial assessment completed?</span>
                            <input type='date' id="dtBiopsychosocialCompleted" name="dtBiopsychosocialCompleted" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Results:</span> <span>Instructions: Provide the diagnosis.</span><br />
                    <textarea id="txtResults" name="txtResults" className='add-only'></textarea>
                </p>
                <p>
                    <b> Brief Overview </b>
                    <span className='small'>Instructions:
                        Provide information for behaviors and issues within the home, at school and in the
                        community.</span>
                </p>
                <p>
                    <span className='eleHeader'>Home:</span>
                    <textarea id="txtHome" name="txtHome" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>School:</span>
                    <textarea id="txtSchool" name="txtSchool" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Community:</span>
                    <textarea id="txtCommunity" name="txtCommunity" className='add-only'></textarea>
                </p>
                <h3>
                    Issues</h3>
                <p>
                    <span className='eleHeader'>Issues  for the Court's Attention:</span>
                    <span className='small'>
                        Instructions: Avoid repeating information that has already been reported. This section
                        is the place to synthesize all of the factual information that has been related
                        in the previous section. Therapeutic concerns, educational progress or any other
                        pressing issues should be stated here.
                    </span>
                    <br />
                    <textarea id="txtIssues" name="txtIssues" className='add-only'></textarea></p>
                <h3>
                    Next Steps</h3>
                <p>
                    <span className='eleHeader'>Recommendations:</span> <span className='small'>Instructions:
                        Recommendations should be stated simply, clearly and concisely. The recommendations
                        are the logical course of action based on the facts and the isues for the court's
                        attention.</span><br />
                    <textarea id="txtRecommendations" name="txtRecommendations" className='add-only'></textarea>
                </p>


            </div>
        </form >
    )
}